export default function AmbienteKafe(){
    return(
        <div className="ambienteKafeImg">
        </div>
    )
}